export default {
    CLICK_TO_PLAY: 'clickToPlay',
    LEAVE_BEHIND: 'leaveBehind',
};
